import { helper } from "@ember/component/helper";
import dayjs from "dayjs";

export default helper(function dateFormat([date, formatString]) {
  return dayjs(date).format(formatString);
});
